<template>
  <!-- 巡查记录 -->
  <div class="page_box">
    <div class="page_option_box">
      <!-- <div class="option_box" style="width:10%">
        <el-button
          type="danger"
          plain
          size="mini"
          icon="el-icon-circle-close"
          @click="delData()"
          :disabled="ids.length < 1 ? true : false"
          >删除</el-button
        >
      </div>
      <div class="search_box" style="width:90%"></div> -->
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="resData.list"
          v-loading="tableLoading"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <!-- <el-table-column
            type="selection"
            width="40"
            align="center"
          ></el-table-column> -->
          <el-table-column label="序号" width="80" align="center">
            <template v-slot="scope">
              {{ reqData.pageSize * (reqData.pageNum - 1) + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="placeName"
            label="地点名称"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="inspector"
            label="巡查人"
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column
            prop="actualInspector"
            label="实际巡查人"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column prop="targetedContent" label="内容" align="center">
          </el-table-column>
          <el-table-column
            prop="actualLatitudeLongitude"
            label="实际巡查经纬度"
            width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="actualPatrolTime"
            label="实际巡查时间"
            width="150"
            align="center"
          >
            <template v-slot="rowData">
              {{ rowData.row.actualPatrolTime != 0 ? $Common.dateFormatDateTwo(rowData.row.actualPatrolTime) : "暂未巡查" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="startTime"
            label="任务开始时间"
            width="150"
            align="center"
          >
            <template v-slot="rowData">
              {{ $Common.dateFormatDateTwo(rowData.row.startTime) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="actualPatrolTime"
            label="任务结束时间"
            width="150"
            align="center"
          >
            <template v-slot="rowData">
              {{ $Common.dateFormatDateTwo(rowData.row.endTime) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="inspectionNotes"
            label="备注"
            align="center"
          >
          </el-table-column>

          <el-table-column prop="supervisorsStatus" label="状态" width="80" align="center">
            <template v-slot="scope">
              <el-tag v-if="scope.row.supervisorsStatus == 0" type="danger">未巡查</el-tag>
              <el-tag v-if="scope.row.supervisorsStatus == 1" type="success">已巡查</el-tag>
              <el-tag v-if="scope.row.supervisorsStatus == 2" type="info">已过期</el-tag>
              <!-- {{
                $store.state.select.patrolState[scope.row.supervisorsStatus]
                  .name
              }} -->
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="reqData.pageNum"
          :page-size="reqData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="resData.total"
        >
        </el-pagination>
      </div>
    </div>
    <patrol-location-dialog :selectId="selectId" :resize="resize"></patrol-location-dialog>
  </div>
</template>

<script>
import PatrolLocationDialog from "./components/PatrolLocationDialog";
export default {
  name: "",
  components: {
    PatrolLocationDialog
  },
  props: {},
  data() {
    return {
      // 请求数据
      reqData: {
        schoolId: this.$store.state.schoolId,
        pageNum: 1,
        pageSize: 20
      },
      resData: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: []
      },
      ids: [],
      tableLoading: false,
      selectId: 0,
      resize: 0
    };
  },
  created() {},
  mounted() {
    this.getList();
  },
  watch: {},
  computed: {},
  methods: {
    handleCurrentChange(val) {
      this.reqData.pageNum = val;
      this.getList();
      console.log(`当前页: ${val}`);
    },
    async getList() {
      this.tableLoading = true;
      let req = Object.assign({}, this.reqData);
      let res = await this.$Http.getPatrolLocationListRecord(req);
      this.tableLoading = false;
      if (res.code == 200) {
        this.resData = res.data;
      } else if (res.code == 101) {
        this.resData = {
          list: [],
          total: 0
        };
      } else {
        this.resData.list = [];
        this.resData.total = 0;
        this.$message({
          type: "error",
          message: "列表获取失败"
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.select-cascader {
  width: 120px;
  margin-left: 5px;
}
.select-cascader-1 {
  width: 144px;
  margin-left: 2px;
}
.select-date {
  width: 400px;
}
.select-input {
  width: 132px;
  margin-left: 2px;
}
.select-btn {
  margin-left: 2px;
}
.special {
  color: #fc4747;
}
</style>
